import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Messages, { AccountMessages } from './pages/Messages';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/admin/UserManagement';
import UserProfile from './pages/profile/UserProfile';

// Layouts
import DashboardLayout from './layouts/DashboardLayout';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div>加载中...</div>;
  }
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

// Admin Route component
const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div>加载中...</div>;
  }
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  if (currentUser.role !== 'admin') {
    return <Navigate to="/accounts" />;
  }
  
  return children;
};

const App = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/accounts" replace />} />
              <Route path="dashboard" element={<Navigate to="/accounts" replace />} />
              
              {/* Add more user routes here */}
              <Route path="accounts" element={<Dashboard />} />
              <Route path="accounts/:accountId" element={<div>账户详情页面</div>} />
              <Route path="accounts/new" element={<div>新建账户页面</div>} />
              <Route path="messages" element={<Messages />} />
              <Route path="messages/:accountId" element={<AccountMessages />} />
              <Route path="profile" element={<UserProfile />} />
              
              {/* Admin routes */}
              <Route path="admin/users" element={
                <AdminRoute>
                  <UserManagement />
                </AdminRoute>
              } />
            </Route>
            
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App; 